import { render, staticRenderFns } from "./InventoryProductDetails.vue?vue&type=template&id=ed372e2c&scoped=true&"
import script from "./InventoryProductDetails.vue?vue&type=script&lang=ts&"
export * from "./InventoryProductDetails.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./InventoryProductDetails.vue?vue&type=style&index=1&id=ed372e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed372e2c",
  null
  
)

export default component.exports